import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { LoadingIndicatorModule } from '../loading-indicator/loading-indicator.module';
import { VisionButtonModule } from '../vision-button/vision-button.module';
import { BundleBuilderComponent } from './bundle-builder/bundle-builder.component';
import { BundleProductCardComponent } from './bundle-product-card/bundle-product-card.component';

@NgModule({
  exports: [BundleBuilderComponent],
  imports: [
    CommonModule,
    FormsModule,
    QueryParamModule,
    FontAwesomeModule,
    VisionButtonModule,
    LoadingIndicatorModule,
    BundleBuilderComponent,
    BundleProductCardComponent,
  ],
})
export class BundleBuilderModule {}
